import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommunicationCenterService } from '@modules/communication-center';
import { DynamicNavigationService } from '../../../navigation/dynamic-navigation.service';
import { DataEntity } from 'octopus-connect';

@Injectable({
  providedIn: 'root'
})
export class BdMenuService {
  private isMenuSet = false;
  private authSubscription: Subscription;

  constructor(
    private communicationCenter: CommunicationCenterService,
    private dynamicNavigation: DynamicNavigationService
  ) {
    this.subscribeToAuthChanges();
  }

  private subscribeToAuthChanges(): void {
    this.authSubscription = this.communicationCenter
      .getRoom('authentication')
      .getSubject('userData')
      .subscribe((data: DataEntity) => {
        if (data) {
          this.addBdToolMenu();
        } else {
          this.removeBdToolMenu();
        }
      });
  }

  private addBdToolMenu(): void {
    if (this.dynamicNavigation.menuExist('level0', 'tools') && !this.isMenuSet) {
      this.dynamicNavigation.addChildTo('level0', 'tools', {
        'id': 'bdList',
        'title': 'bdList',
        'translate': 'bd.title',
        'type': 'item',
        'url': '/bd-tool/list',
      });
      this.isMenuSet = true;
      this.dynamicNavigation.generateMenu('level0', true);
    }
  }

  private removeBdToolMenu(): void {
    if (this.isMenuSet) {
      this.dynamicNavigation.clearMenuItem('level0', 'bdList');
      this.isMenuSet = false;
      this.dynamicNavigation.generateMenu('level0', true);
    }
  }
}